import React, { useEffect, useState } from 'react'
import { Error as ErrorMessage, EventListings } from 'fitch_storybook'

type FeatureFlag = {
  name: string
  isActive: boolean
}

export default function MfeEvents({ data, languageSlug, pathname }: any) {
  const [state, setState] = useState({
    content: [],
    useRelativeUrl: false,
    error: false,
    loading: true
  })

  // We want to avoid forcing the home page to load all the events data, so instead
  // fetch it from the appropriate language's evens page
  useEffect(() => {
    fetch(
      `/page-data/${
        languageSlug === 'en' ? '' : `${languageSlug}/`
      }events/page-data.json`
    )
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch events data')
        return res.json()
      })
      .then((res) => {
        const cfData = res?.result?.data
        const featureFlags: FeatureFlag[] = cfData?.featFlag?.featFlag || []
        const events = cfData?.allContentfulEvent?.nodes || []
        const useRelativeUrlFlag = featureFlags.find(
          (e) => e.name === 'useEventRelativeUrl'
        )

        setState({
          content: events,
          useRelativeUrl: !!useRelativeUrlFlag?.isActive,
          error: false,
          loading: false
        })
      })
      .catch(() =>
        setState({
          content: [],
          error: true,
          loading: false,
          useRelativeUrl: false
        })
      )
  }, [data, languageSlug, pathname])

  if (state.error) {
    return <ErrorMessage message="Sorry, something went wrong" />
  }

  const { getSearchFilters } = data

  const sectors = getSearchFilters
    ? getSearchFilters.filter((filterType) => {
        return filterType.value === 'sector'
      })
    : { items: [], value: '' }

  const region = getSearchFilters
    ? getSearchFilters.filter((filterType) => {
        return filterType.value === 'region'
      })
    : { items: [], value: '' }

  return (
    <EventListings
      secFilType={sectors && sectors[0]}
      regFilType={region && region[0]}
      isHomePage={pathname === '/'}
      eventLangSlug={languageSlug}
      items={state.content}
      useRelativeUrl={state.useRelativeUrl}
      eventsDataLoading={state.loading}
    />
  )
}
